/* Подбор-ситуация (2026-07-18, поворот 2): не «сколько стоит» и не «какой архетип»,
   а по ситуации клиента → карта потерь → решение → что даст → разбор. Без цены.
   Заменил archetypeScore (цена/триплет/E-иерархия срезаны — оффер стал широким:
   беру любые задачи автоматизации/внедрения, цену считаем в разборе по смете).

   Логика тривиальная — keyed lookup; вынесено сюда, чтобы контент карточек был в
   одном месте и тест ловил незаполненную опцию (иначе карта потерь/решение/что даст
   молча пусты). Контент честный: ничего не выдумано.

   (2026-07-19) ₽ на карточке всё же появились — но не выдуманы, а посчитаны из
   двух чисел, которые вводит сам клиент (часов/неделю × своя оценка часа). Это не
   цена услуги (её на странице по-прежнему нет), а его собственная цифра. См. calcLoss. */

/* id опции → три строки карточки. loss = где утекают часы/в чём трение сейчас. */
export const NEEDS = {
  faq: {
    label: "Отвечать на повторяющиеся вопросы и искать по своим документам",
    verdict: "ai",
    short: "Одни и те же вопросы",
    why: "Спрашивают по-разному, а ответ лежит в документах: понять вопрос и найти ответ должен ИИ.",
    loss: "На одни и те же вопросы отвечают заново, каждый раз с нуля",
    solution: "База знаний, которая отвечает по твоим документам",
    gain: "Ответ за секунды и по делу, без «спроси Марину»",
  },
  text: {
    label: "Разобрать поток текста: отзывы, заявки, переписка",
    verdict: "ai",
    short: "Отзывы, заявки, чаты",
    why: "Текст приходит в свободной форме, правилами его не разобрать, а ИИ читает и сортирует.",
    loss: "Отзывы, заявки и переписку разбирают и сортируют руками",
    solution: "Слой на базе ИИ, который читает поток текста и вытаскивает суть",
    gain: "Сводка, приоритет и структура сразу, без ручного разбора",
  },
  voice: {
    label: "Наговорить голосом и получить форму, задачу или отчёт",
    verdict: "ai",
    short: "Надиктовать отчёт",
    why: "Речь нужно сначала понять и только потом разложить по полям, это работа для ИИ.",
    loss: "Наговорил голосом, а потом руками оформляешь в форму или отчёт",
    solution: "Слой на базе ИИ, который превращает голос в структуру",
    gain: "Форма, задача или отчёт из голоса, без переписывания",
  },
  data: {
    label: "Спросить по своим данным человеческим языком",
    verdict: "ai",
    short: "Спросить у данных",
    why: "Ты спрашиваешь словами, а ответ лежит в таблицах: связать их может ИИ.",
    loss: "Чтобы узнать цифру, лезешь в таблицы и считаешь вручную",
    solution: "Аналитический слой на базе ИИ поверх твоих данных",
    gain: "Спрашиваешь словами и получаешь готовую цифру",
  },
  dashboard: {
    label: "Видеть ключевые цифры бизнеса в одном месте, без ручных отчётов",
    verdict: "order",
    short: "Цифры в одном месте",
    why: "Цифры известны заранее и считаются одинаково, поэтому хватит порядка в данных, ИИ тут не нужен.",
    loss: "Чтобы понять, как идут дела, лезешь в разные таблицы и CRM и каждый раз считаешь сам",
    solution: "Дашборд с ключевыми метриками бизнеса, который обновляется сам, без ручной сборки",
    gain: "Открыл и увидел цифры, не собирая отчёт руками",
  },
  insights: {
    label: "Чтобы данные сами анализировались и присылали выводы",
    verdict: "ai",
    short: "Выводы приходят сами",
    why: "Мало показать цифры, их нужно сопоставить и объяснить, а это работа для ИИ.",
    loss: "Чтобы получить вывод, каждый раз приходится смотреть в данные и сопоставлять цифры руками",
    solution: "Агент на базе ИИ, который сам анализирует данные и присылает вывод или отчёт",
    gain: "Вывод готов сам, копаться в данных и сравнивать цифры не нужно",
  },
  telegram: {
    label: "Принимать заявки, записи или предзаказы в Telegram",
    verdict: "maybe",
    short: "Заявки в Telegram",
    why: "Бот по готовым шагам обойдётся без ИИ, он нужен, только если бот должен понимать свободный текст.",
    loss: "Заявки, записи и напоминания ведутся вручную или вообще нигде, и поэтому теряются",
    solution: "Бот или приложение внутри Telegram: приём заявок, запись, каталог, предзаказ, программа лояльности",
    gain: "Приём и запись идут сами, ничего не теряется, звонить и напоминать вручную не нужно",
  },
  landing: {
    label: "Лендинг, каталог, витрина",
    verdict: "order",
    short: "Лендинг или каталог",
    why: "Страница показывает одно и то же всем: хватит хорошей вёрстки и текста, ИИ тут ни при чём.",
    loss: "Страницы для этого нет, поэтому клиенту вручную объясняешь одно и то же в переписке",
    solution: "Быстрая страница на Next.js, свёрстанная под твою задачу и текст",
    gain: "Чистая страница под задачу, без конструктора и лишнего",
  },
  widget: {
    label: "Калькулятор, квиз или форма записи на сайт",
    verdict: "maybe",
    short: "Расчёт и запись на сайте",
    why: "Расчёт по формуле обойдётся без ИИ, он нужен, только если клиент описывает задачу своими словами.",
    loss: "На сайте нельзя посчитать или записаться, поэтому расчёт и запись ты делаешь вручную за клиента",
    solution: "Виджет на сайт: калькулятор, квиз или форма записи",
    gain: "Считает и ведёт к заявке прямо на странице",
  },
};

/* Вердикт: нужен ли тут ИИ. Разметка утверждена владельцем 2026-10-27; «maybe» там, где
   бот или виджет бывают и с ИИ, и без, решает разбор. Подписи бейджей: copy-podbor-hero. */
export const VERDICTS = {
  ai: "ИИ нужен",
  order: "Хватит порядка",
  maybe: "ИИ по ситуации",
};

/* Пример на ползунках: не слова клиента, а стартовая точка, чтобы цифра была видна сразу.
   В форму часы и ставка уходят, только если человек их сдвинул. */
export const SLIDERS = {
  hours: { min: 1, max: 60, step: 0.5, example: 5 },
  rate: { min: 300, max: 10000, step: 100, example: 1500 },
};

export const DEFAULT_NEED = "faq";

/* need → { label, loss, solution, gain }. Бросает на неизвестной опции. */
export const findSolution = (need) => {
  const n = NEEDS[need];
  if (!n) throw new Error(`situationFinder: неизвестная опция "${need}"`);
  return n;
};

/* (2026-07-19) Деньги — только из ввода самого клиента, не выдуманы: часы/неделю ×
   своя оценка часа × 52 недели. Мусор/ноль/отрицательное → null (не рисуем нолики).
   Округление до целого — вилка не нужна, это прикидка по двум числам клиента. */
export const calcLoss = (hoursPerWeek, ratePerHour) => {
  const h = Number(hoursPerWeek);
  const r = Number(ratePerHour);
  if (!Number.isFinite(h) || !Number.isFinite(r) || h <= 0 || r <= 0) return null;
  const hoursYear = Math.round(h * 52);
  const moneyYear = Math.round(h * 52 * r);
  return { hoursYear, moneyYear };
};

export const formatNum = (n) => new Intl.NumberFormat("ru-RU").format(n);
export const formatRub = (n) => `${formatNum(n)} ₽`;
